import React from "react";
import {
    reduxForm,
    InjectedFormProps,
    ConfigProps,
    FormDecorator,
    formValueSelector,
} from "redux-form";
import { Button, CircularProgress, Grid, FormControlLabel } from "material-ui";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextfield from "../../../components/form/RenderTextField";
import { ReduxDispatch, ReduxState } from "../../../ducks/reducers";
import { connect } from "react-redux";
import validate from "./ChangePasswordValidator";
import { blue } from "material-ui/colors";

export interface ChangePasswordFormData {
    password: string;
    verifyPassword: string;
}

interface IChangePasswordFormProps {
    form: string;
    onSubmit: (data: ChangePasswordFormData) => void;
}

interface IChangePasswordReduxProps {}
interface IChangePasswordDispatchProps {}

interface ChangePasswordFormState {}

type ChangePasswordFormProps = IChangePasswordFormProps &
    IChangePasswordReduxProps &
    IChangePasswordDispatchProps &
    InjectedFormProps<ChangePasswordFormData, IChangePasswordFormProps>;

const ChangePasswordForm: React.SFC<ChangePasswordFormProps> = (
    props: ChangePasswordFormProps
) => {
    return (
        <form onSubmit={props.handleSubmit(props.onSubmit)}>
            <Grid container>
                <Grid item xs={12} className="LoginInput">
                    <ExtendedField
                        component={renderTextfield}
                        name="password"
                        type="password"
                        placeholder=""
                        adornment=""
                        label={"Salasana"}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12} className="LoginInput">
                    <ExtendedField
                        component={renderTextfield}
                        name="verifyPassword"
                        type="password"
                        placeholder=""
                        adornment=""
                        label={"Vahvista salasana"}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div className={"loginButton"}>
                        <Button
                            variant="raised"
                            type="submit"
                            disabled={props.submitting || props.invalid}
                        >
                            Vaihda salasana
                            {props.submitting && (
                                <CircularProgress
                                    size={24}
                                    style={{
                                        color: blue[500],
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        marginTop: -12,
                                        marginLeft: -12,
                                    }}
                                />
                            )}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </form>
    );
};

const form = reduxForm<ChangePasswordFormData, IChangePasswordFormProps>({
    validate,
})(ChangePasswordForm);

const selector = formValueSelector("changepassword");
const mapStateToProps = (state: ReduxState): IChangePasswordReduxProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IChangePasswordDispatchProps => {
    return {};
};

export default connect<
    IChangePasswordReduxProps,
    IChangePasswordDispatchProps,
    IChangePasswordFormProps
>(
    mapStateToProps,
    mapDispatchToProps
)(form as any);



// WEBPACK FOOTER //
// ./src/views/profile/components/ChangePasswordForm.tsx